import css from '@styled-system/css';
import styled from '@emotion/styled';
import { Modal } from '@medicalwebexperts/ui';

const StyledModal = styled(Modal)(
  { label: 'CustomModal' },
  css({
    border: 'none',
    outline: 'none',
    button: {
      '&.noOutline': {
        outline: 'none',
      },
      outlineColor: 'primary.main',
    },
  }),
);

export default StyledModal;
